/**
 * Badge neutral para project.methodology. Usa surface-muted (no compite
 * visualmente con los status badges, que son los que importan).
 */

import { useTranslation } from 'react-i18next'

import type { ProjectMethodology } from '../../api/projects'

interface Props {
  methodology: ProjectMethodology
}

export function MethodologyBadge({ methodology }: Props) {
  const { t } = useTranslation('projects')
  return (
    <span className="rounded bg-surface-muted px-2 py-0.5 text-xs font-medium text-ink-muted">
      {t(`methodology.${methodology}` as const)}
    </span>
  )
}
